'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
export function useQueryLogger() {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== queryClient) {
    t0 = () => {
      if (process.env.NODE_ENV !== "development") {
        return;
      }
      const unsubscribe = queryClient.getQueryCache().subscribe(_temp);
      return () => {
        unsubscribe();
      };
    };
    t1 = [queryClient];
    $[0] = queryClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp(event) {
  if (event.type === "added") {}
  if (event.type === "updated") {
    const query_0 = event.query;
    const action = event.action;
    if (action?.type === "fetch") {
      query_0.isStale();
    }
    if (action?.type === "success") {}
  }
}